import ContractElectronic from './ContractElectronicContainer';

export { ContractElectronic };



// WEBPACK FOOTER //
// ./src/modules/home/contractElectronic/index.js